module.exports = __webpack_public_path__ + "img/audio-zh-active.66db7f2c.gif";